import "./index.less";
import template from "./index.html";
import onboardingModeHandler from "./onboarding-mode-handler/index.js";
import onboardingDirections from "./onboarding-directions.js";
import veslLogo from "../../images/vesl_logo.svg";

import { FORMS_REQUESTABLE } from "routes";

export function controller(
	api,
	loadingService,
	$state
) {
	const ctrl = this;

	ctrl.selectedAgency = undefined;
	ctrl.selectedForm = undefined;
	ctrl.requestableForms = [];
	ctrl.veslLogo = veslLogo;

	ctrl.$onInit = () => {
		loadingService.watch(api.get(FORMS_REQUESTABLE))
			.then(forms => {
				ctrl.requestableForms = forms;

				if($state.params.form) {
					ctrl.selectedForm = forms.find(f => f.Code === $state.params.form);
				}
			});
	};

	ctrl.handleAgencySelected = ($event) => {
		ctrl.selectedAgency = $event.agency;
		ctrl.selectedForm = undefined;
		syncSelectedFormToUrl();
	};

	ctrl.handleFormSelected = ($event) => {
		ctrl.selectedAgency = $event.agency;
		ctrl.selectedForm = $event.form;
		syncSelectedFormToUrl();
	};

	function syncSelectedFormToUrl() {
		$state.go("authenticated.welcome", { form: ctrl.selectedForm?.Code ?? null }, { location: "replace" });
	}
}

export default angular
	.module("vesl.screens.welcome", [onboardingModeHandler, onboardingDirections])
	.component("welcome", { template, controller }).name;
